<template>
  <v-layout wrap style="height: 100px">
    <v-navigation-drawer v-model="enableFilters" persistent fixed width="600">
      <v-toolbar color="white" class="elevation-0">
        <v-toolbar-title>Filtros</v-toolbar-title>
      </v-toolbar>
      <v-spacer></v-spacer>
      <v-form>
        <v-container>
          <v-layout>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuStartAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedStartAtFormatted"
                    label="Data Inicial"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startAt"
                  no-title
                  @input="menuStartAt = false"
                  class="“no-pointer-events”"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuEndAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedEndAtFormatted"
                    label="Data Final"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endAt"
                  no-title
                  @input="menuEndAt = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <div>
            <v-subheader>Outros Filtros</v-subheader>
          </div>
          <v-layout v-if="partnerLevel === 'establishment'">
            <!--blank if establishment-->
          </v-layout>
          <v-layout v-else>
            <partner />
          </v-layout>
          <v-layout>
            <status />
          </v-layout>
          <v-layout>
            <brand />
          </v-layout>
          <v-layout>
            <order />
          </v-layout>

          <v-btn @click="getResources">Enviar</v-btn>
          <v-btn @click="reset">Limpar</v-btn>
          <v-btn @click="desableFilters">Fechar</v-btn>
        </v-container>
      </v-form>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  created() {
    this.$store.dispatch("account/getAccount");
  },
  components: {
    Status: () => import("./options/Status.vue"),
    Brand: () => import("./options/Brand.vue"),
    Order: () => import("./options/Order.vue"),
    Partner: () => import("./options/Partner.vue"),
  },
  data: (vm) => ({
    startAt: null,
    endAt: null,
    startAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'start'),
    endAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'end'),
    menuStartAt: false,
    menuEndAt: false,
    enableFilters: false,
  }),
  computed: {
    ...mapGetters({
      filters: "deposits/filter",
      limit: "deposits/limit",
      page: "deposits/page",
      storeStatus: "deposits/filtersStatus",
      storeCreditCardBrand: "deposits/filtersCardBrand",
      storeOrdination: "deposits/filtersOrdination",
      storeShowFilters: "deposits/showFilters",
      storePartner: "deposits/filtersPartner",
      partnerLevel: "account/partner",
    }),
    showFilters: {
      get() {
        return this.storeShowFilters;
      },
      set(value) {
        this.$store.dispatch("deposits/showFilters", value);
      }
    },
    status: {
      get() {
        return this.storeStatus;
      },
      set(newStatus) {
        this.$store.dispatch("deposits/setStatus", { business: newStatus });
      },
    },
    cardBrand: {
      get() {
        return this.storeCreditCardBrand;
      },
      set(newCardBrand) {
        this.$store.dispatch("deposits/setCardBrand", newCardBrand);
      },
    },
    partner: {
      get() {
        return this.storePartner;
      },
      set(newPartner) {
        this.$store.dispatch("deposits/setPartner", { business: newPartner });
      },
    },
    ordination: {
      get() {
        return this.storeOrdination;
      },
      set(value) {
        this.$store.dispatch("deposits/setOrdination", { business: value });
      },
    },
    computedStartAtFormatted() {
      return this.formatDate(this.startAt, 'start');
    },
    computedEndAtFormatted() {
      return this.formatDate(this.endAt, 'end');
    },
  },
  watch: {
    storeShowFilters(newValue) {
      this.enableFilters = newValue;
    },
    startAt(val) {
      this.startAtFormatted = this.formatDate(this.startAt, 'start');
      this.$store.dispatch('deposits/setInitialDate', this.startAtFormatted);
    },
    endAt(val) {
      this.endAtFormatted = this.formatDate(this.endAt, 'end');
      this.$store.dispatch('deposits/setFinalDate', this.endAtFormatted);
    },
  },
  methods: {
    /* eslint-disable */
    getResources() {
      const params = {
        page: this.page,
        limit: this.limit,
        filterrific: {
          with_due_on_between: {
            start_at: this.formatDate(this.startAt, 'start'),
            end_at: this.formatDate(this.endAt, 'end'),
          },
          status: this.status,
          with_credit_card_brand: this.cardBrand,
          with_partner: this.partner,
          sorted_by: this.ordination,
        },
      };
      this.$store.dispatch("deposits/load", params);
      this.desableFilters();
    },
    desableFilters() {
      this.$store.dispatch("deposits/showFilters", false);
      this.enableFilters = false;
    },
    reset() {
      this.$store.dispatch("deposits/resetFilters", this.filters);
      this.$store.dispatch("deposits/load");
    },
    formatDate(date, kind) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (kind == 'start') { 
        return `${year}-${month}-${day} 00:00:00`;
      } else {
        return `${year}-${month}-${day} 23:59:59`;
      }
    }
  },
};
</script>
